import markRowsPinnedInListViewStore from '../actions/triage/markRowsPinnedInListViewStore';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import { actionNames } from 'owa-mail-store-actions';
import { select } from 'satcheljs/lib/legacy';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import { getLocalPinnedTimeStamp } from 'owa-mail-list-store/lib/utils/pinningUtils';
function updateRenewTimeOnConversation(rowKey, tableViewId, shouldMarkAsPinned) {
    var tableConversationRelation = getTableConversationRelation(rowKey, tableViewId);
    if (!tableConversationRelation) {
        return;
    }
    // If this is unpin action set the lastDeliveryOrRenewTime to lastDeliveryTime
    if (!shouldMarkAsPinned) {
        tableConversationRelation.lastDeliveryOrRenewTimeStamp =
            tableConversationRelation.lastDeliveryTimeStamp;
        return;
    }
    // If this is pin action, we need to convert the utc pinned time to local time,
    // as server always returns the local time.
    var localPinnedTimeStamp = getLocalPinnedTimeStamp();
    if (localPinnedTimeStamp) {
        tableConversationRelation.lastDeliveryOrRenewTimeStamp = localPinnedTimeStamp;
    }
}
export default select({
    tableViews: function () { return listViewStore.tableViews; },
    updateRenewTimeAction: function () { return updateRenewTimeOnConversation; },
})(function markConversationsAsPinnedStitch(state) {
    subscribe(actionNames.MarkConversationsAsPinned, function (conversationIds, tableViewId, shouldMarkAsPinned) {
        var tableView = state.tableViews.get(tableViewId);
        var rowKeys = getRowKeysFromRowIds(conversationIds, tableView);
        markRowsPinnedInListViewStore(rowKeys, tableViewId, shouldMarkAsPinned, state.updateRenewTimeAction);
    });
});
//# sourceMappingURL=markConversationsAsPinnedStitch.js.map